import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../css/CaroselHome.css";

const images = [
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/women-9114238_1280.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/aerial-panoramic-landscape-view-road-from-village.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/beautiful-green-field-costa-rican-countryside.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/beautiful-pavement-houses-surrounded-by-grassy-fields-captured-gambia-africa.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/house-8200038_1280.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/modern-luxury-home-with-beautiful-landscape.jpg",
    "https://mybucketraza.s3.ap-south-1.amazonaws.com/carosel-image/image/turnip-8266093_1280.jpg"

];

// const images = [
//     "https://images.unsplash.com/photo-1501004318641-b39e6451bec6?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1615874959474-d609969a0f1a?auto=format&fit=crop&w=1200&q=80",
//   ];


// const images = [
//     "https://images.unsplash.com/photo-1600431521340-491eca880813?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&w=1200&q=80",
//     "https://images.unsplash.com/photo-1615874959474-d609969a0f1a?auto=format&fit=crop&w=1200&q=80",
//   ];


const CaroselHome = () => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section
            className="hero-section-carosel"
            style={{ backgroundImage: `url(${images[current]})` }}
        >
            <div className="overlay-carosel"></div>
            <div className="hero-content-carosel">
                <h1>Welcome to <span style={{ color: "#FFD700" }}>KhetBazaar</span></h1>
                <p style={{
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    padding: "10px 15px",
                    borderRadius: "8px",
                    color: "white"
                }}>
                    Buy, Sell, or Lease Land Across India — Fast, Easy, and Transparent
                </p>
                <p style={{ fontStyle: "italic", marginTop: "5px" }}>अब ज़मीन की हर डील आसान और भरोसेमंद</p>
                <div className="hero-buttons-carosel">
                    <Link to="/landlist" className="btn landlist-btn">Explore Lands</Link>
                    <Link to="/register-land" className="btn register-land-btn">List Your Property</Link>
                </div>
            </div>
            <div className="hero-gradient-carosel"></div>
        </section>
    );
}

export default CaroselHome;